//prod
// const server = 'https://back.kedr.dev.yourtar.ru/';

//stage
const server = process.env.REACT_APP_SERVER_URL ?? 'https://theact.miniapp.yourtar.ru';
// const socket = 'http://127.0.0.1:8000/.well-known/mercure?topic=';

//dev
// const server = 'http://localhost:8000/';
// const socket = 'http://127.0.0.1:8000/';

export const serverUrl = server + '/api';
export const socketUrl = 'https://сервер.смурно.демо-стенд.рф/.well-known/mercure?topic=';
export const version = '1.1.0';

// Kill switch. `true` => the app renders the suspension screen instead of
// Layout and never touches the API. Deliberately a committed constant and
// not an env var: the deploy workflow builds straight from the checkout
// and never writes the root .env that docker-compose reads, so an env
// flag would silently never reach the build. Flip it, push to main, and
// the autodeploy rebuilds.
export const isSuspended = true;
